import { render, staticRenderFns } from "./SettingUsers.vue?vue&type=template&id=51f9bcb6&"
import script from "./SettingUsers.vue?vue&type=script&lang=js&"
export * from "./SettingUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports